import { mapGetters } from "vuex";
import {
  permissionsToBKPermissions as permissions,
  allBKPermissionKeys,
} from "@/middleware/pageAccessManager";

const userAccessManagementMixin = {
  data: function() {
    return {};
  },
  computed: {
    ...mapGetters("user", {
      getViewPermissions: "getViewPermissions",
      getUpdatePermissions: "getUpdatePermissions",
      getDeletePermissions: "getDeletePermissions",
      getCurrUserType: "getCurrUserType",
      doRestrictHighPriorityUsers: "doRestrictHighPriorityUsers",
    }),
    getAccessDeniedMsg() {
      return "You may not have the appropriate permissions to perform the operation";
    },
    userTypes() {
      return {
        pond_owner: {
          type_name: "Usrs_owner",
          description: "Usrs_owner_full_access_msg",
          add_btn_text: "Usrs_add_ownr",
          value: "POND_OWNER",
        },
        pond_manager: {
          type_name: "Comn_manager",
          description: "Comn_mangers_have_access_msg",
          add_btn_text: "Usrs_add_mng",
          value: "POND_MANAGER",
        },
        pond_technician: {
          type_name: "Usrs_pond_techno",
          description: "Usrs_pond_technicians_access_msg",
          add_btn_text: "Usrs_add_tech",
          value: "POND_TECHNICIAN",
        },
        pond_worker: {
          type_name: "Usrs_pond_worker",
          description: "Usrs_pond_worker_login_msg",
          add_btn_text: "Usrs_add_wrkr",
          value: "POND_WORKER",
        },
        no_access: {
          type_name: "Comn_no_access",
          description: "Usrs_no_access_usr",
          value: "NO_ACCESS",
        },
        super_admin: {
          type_name: "super_admin",
          description: "SUPER ADMIN",
          value: "SUPER_ADMIN",
        },
      };
    },
    userRolesInPondlogs() {
      return {
        pond_owner: {
          type_name: "Usrs_owner",
          description: "Usrs_owner_full_access_msg",
          add_btn_text: "Usrs_add_ownr",
          value: "POND_OWNER",
        },
        pond_manager: {
          type_name: "Comn_manager",
          description: "Comn_mangers_have_access_msg",
          add_btn_text: "Usrs_add_mng",
          value: "POND_MANAGER",
        },
        pond_technician: {
          type_name: "Usrs_pond_techno",
          description: "Usrs_pond_technicians_access_msg",
          add_btn_text: "Usrs_add_tech",
          value: "POND_TECHNICIAN",
        },
        pond_worker: {
          type_name: "Usrs_pond_worker",
          description: "Usrs_pond_worker_login_msg",
          add_btn_text: "Usrs_add_wrkr",
          value: "POND_WORKER",
        },
        no_access: {
          type_name: "Comn_no_access",
          description: "Usrs_no_access_usr",
          value: "NO_ACCESS",
        },
      };
    },
    permissionsObj() {
      return {
        MANAGE_OVERVIEW: {
          name: this.$t("Comn_manage_overview"),
          key: "MANAGE_OVERVIEW",
          allowedActions: {
            view: permissions.MANAGE_OVERVIEW.VIEW,
          },
        },
        MANAGE_CULTURE: {
          name: this.$t("Comn_manage_culture"),
          key: "MANAGE_CULTURE",
          allowedActions: {
            view: permissions.MANAGE_CULTURE.VIEW,
            update: permissions.MANAGE_CULTURE.UPDATE,
          },
        },
        MANAGE_SCHEDULES: {
          name: this.$t("permisssion_manage_schedules"),
          key: "MANAGE_SCHEDULES",
          allowedActions: {
            view: permissions.MANAGE_SCHEDULES.VIEW,
            update: permissions.MANAGE_SCHEDULES.UPDATE,
            delete: permissions.MANAGE_SCHEDULES.DELETE,
          },
        },
        MANAGE_DEVICES: {
          name: this.$t("Comn_manage_devices"),
          key: "MANAGE_DEVICES",
          allowedActions: {
            view: permissions.MANAGE_DEVICES.VIEW,
            update: permissions.MANAGE_DEVICES.UPDATE,
            delete: permissions.MANAGE_DEVICES.DELETE,
          },
        },

        MANAGE_ABW: {
          name: this.$t("Comn_manage_abw"),
          key: "MANAGE_ABW",
          allowedActions: {
            view: permissions.MANAGE_ABW.VIEW,
            update: permissions.MANAGE_ABW.UPDATE,
            delete: permissions.MANAGE_ABW.DELETE,
          },
        },
        MANAGE_HARVEST: {
          name: this.$t("Comn_manage_harvest"),
          key: "MANAGE_HARVEST",
          allowedActions: {
            view: permissions.MANAGE_HARVEST.VIEW,
            update: permissions.MANAGE_HARVEST.UPDATE,
            delete: permissions.MANAGE_HARVEST.DELETE,
          },
        },
        MANAGE_MEDICINE: {
          name: this.$t("Comn_manage_medicine"),
          key: "MANAGE_MEDICINE",
          allowedActions: {
            view: permissions.MANAGE_MEDICINE.VIEW,
            update: permissions.MANAGE_MEDICINE.UPDATE,
            delete: permissions.MANAGE_MEDICINE.DELETE,
          },
        },

        MANAGE_LAB_TESTS: {
          name: "Manage Lab tests",
          key: "MANAGE_LAB_TESTS",
          allowedActions: {
            view: permissions.MANAGE_LAB_TESTS.VIEW,
            update: permissions.MANAGE_LAB_TESTS.UPDATE,
            delete: permissions.MANAGE_LAB_TESTS.DELETE,
          },
        },
        MANAGE_STOCK: {
          name: "Manage Stock",
          key: "MANAGE_STOCK",
          allowedActions: {
            view: permissions.MANAGE_STOCK.VIEW,
            update: permissions.MANAGE_STOCK.UPDATE,
            delete: permissions.MANAGE_STOCK.DELETE,
          },
        },
      };
    },
    getDefaultPermissions() {
      // Technician - Selected locations & Manage Devices permission enabled (by default)
      // Pond Worker - Selected locations & Manage schedules and Manage ABW enabled (by default)
      return {
        POND_TECHNICIAN: [
          // DEVICES
          "VIEW_POND_GUARDS",
          "VIEW_POND_MOTHERS",
          "VIEW_SHRIMP_TALKS",
          "VIEW_GATEWAYS",
          "VIEW_POND_ALERTS",
          "VIEW_PONDS",
          "VIEW_WATER_QUALITY_SUMMARY",
          "UPDATE_POND_GUARDS",
          "UPDATE_POND_MOTHERS",
          "UPDATE_SHRIMP_TALKS",
          "UPDATE_GATEWAYS",
          "DELETE_POND_GUARDS",
          "DELETE_POND_MOTHERS",
          "DELETE_SHRIMP_TALKS",
        ],

        POND_WORKER: [
          // SCHEDULES
          "VIEW_SCHEDULES",
          "VIEW_PONDS",
          "VIEW_MANUAL_FEED",
          "VIEW_GATEWAYS",
          "VIEW_POND_MOTHERS",
          "VIEW_SHRIMP_TALKS",
          "UPDATE_SCHEDULES",
          "UPDATE_SHRIMP_TALKS",
          "UPDATE_POND_MOTHERS",
          "UPDATE_GATEWAYS",
          "DELETE_SCHEDULES",
          // ABW
          "VIEW_POND_SUMMARY",
          "VIEW_PONDS",
          "VIEW_ABW",
          "VIEW_CULTURE",
          "UPDATE_ABW",
          "DELETE_ABW",
        ],
      };
    },
    getAllPermissionKeys() {
      return allBKPermissionKeys;
    },
    isUserOfTypeSuperAdmin() {
      return this.isUserOfType(["super_admin"]);
    },
    isUserOfTypeOwner() {
      return this.isUserOfType(["pond_owner"]);
    },
    userProfileDetails() {
      return this.$store.getters["user/getUserProfile"];
    },
  },
  methods: {
    isHighPriorityUsersRestricted() {
      if (this.doRestrictHighPriorityUsers) {
        throw {
          type: "ACCESS_DENIED",
          errors: [
            {
              message: this.getAccessDeniedMsg,
            },
          ],
        };
      }
    },
    itemsUserCanView(objItems) {
      return Object.keys(objItems).reduce((acc, currItem) => {
        const keyToValidateAccess = objItems[currItem].keyToValidateAccess;
        let authorizations = objItems[currItem][keyToValidateAccess];
        let canViewItem = false;
        if (this.$commonUtils.getType(authorizations) === "object") {
          authorizations = authorizations.VIEW;
        }
        const methodToValidate =
          keyToValidateAccess === "PERMISSIONS"
            ? (x) => this.getViewPermissions[x]
            : (x) => x === this.getCurrUserType;
        canViewItem = authorizations.some(methodToValidate);

        if (canViewItem) {
          acc[currItem] = objItems[currItem];
        }
        return acc;
      }, {});
    },
    isEditable(itemObj) {
      const keyToValidateAccess = itemObj.keyToValidateAccess;
      let authorizations = itemObj[keyToValidateAccess];
      let canEdit = false;
      if (this.$commonUtils.getType(authorizations) === "object") {
        authorizations = authorizations.UPDATE || [];
      }
      if (authorizations.length > 0) {
        const methodToValidate =
          keyToValidateAccess === "PERMISSIONS"
            ? (x) => this.getUpdatePermissions[x]
            : (x) => x === this.getCurrUserType;
        canEdit = authorizations.some(methodToValidate);
      }
      if (!canEdit) {
        throw {
          type: "ACCESS_DENIED",
          errors: [
            {
              message: this.getAccessDeniedMsg,
            },
          ],
        };
      }
    },
    canUserDelete(itemObj) {
      const keyToValidateAccess = itemObj.keyToValidateAccess;
      let authorizations = itemObj[keyToValidateAccess];
      let canEdit = false;
      if (this.$commonUtils.getType(authorizations) === "object") {
        authorizations = authorizations.DELETE || [];
      }
      if (authorizations.length > 0) {
        const methodToValidate =
          keyToValidateAccess === "PERMISSIONS"
            ? (x) => this.getDeletePermissions[x]
            : (x) => x === this.getCurrUserType;
        canEdit = authorizations.some(methodToValidate);
      }

      if (!canEdit) {
        throw {
          type: "ACCESS_DENIED",
          errors: [
            {
              message: this.getAccessDeniedMsg,
            },
          ],
        };
      }
    },
    doUserHasAccess(permissionToBeChecked) {
      if (this.userProfileDetails) {
        const userPermissions =
          this.userProfileDetails && this.userProfileDetails.permissions;
        if (Array.isArray(permissionToBeChecked)) {
          return permissionToBeChecked.some((permission) => {
            return userPermissions.indexOf(permission) > -1;
          });
        } else return userPermissions.indexOf(permissionToBeChecked) > -1;
      }
    },
    isUserOfType(userTypes) {
      const userType =
        this.userProfileDetails && this.userProfileDetails.user_type;
      if (Array.isArray(userTypes)) {
        return userTypes.some((userTypeArg) => {
          return userType === userTypeArg;
        });
      } else return userType === userTypes;
    },
  },
};

export default userAccessManagementMixin;
